import React from 'react';
import {
  FDTable, FDTableBody, FDTableCell, FDTableHead, FDTableRow,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import {
  IncomeInformationTableBodyRow,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeInformation/IncomeInformationTableBodyRow';

const IncomeInformationTable = ({ incomeSummaryCollection, onEditIncome, onDeleteIncome }) => {
  const incomeSummaries = incomeSummaryCollection.resources().list();

  if (incomeSummaries.length === 0) {
    return null;
  }

  return (
    <FDTable size={'sm'}>
      <FDTableHead>
        <FDTableRow>
          <FDTableCell>{'Income source'}</FDTableCell>
          <FDTableCell align={'right'}>{'Amount'}</FDTableCell>
        </FDTableRow>
      </FDTableHead>
      <FDTableBody>
        {incomeSummaries.map((income) => (
          <IncomeInformationTableBodyRow
            key={income.id()}
            income={income}
            onEditIncome={onEditIncome}
            onDeleteIncome={onDeleteIncome}
          />
        ))}
      </FDTableBody>
    </FDTable>
  );
};

IncomeInformationTable.defaultProps = {
  onEditIncome: undefined,
  onDeleteIncome: undefined,
};

IncomeInformationTable.propTypes = {
  incomeSummaryCollection: PropTypes.object.isRequired,
  onEditIncome: PropTypes.func,
  onDeleteIncome: PropTypes.func,
};

export { IncomeInformationTable };
